
const BASE_URL =
  "https://praneeshinfotech.com/kongudevapi/api/address-download-plans";

const getHeaders = () => {
  const token = localStorage.getItem("token");

  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

const apiRequest = async (endpoint = "", options = {}) => {
  const response = await fetch(`${BASE_URL}${endpoint}`, {
    ...options,
    headers: {
      ...getHeaders(),
      ...options.headers,
    },
  });

  let result;

  try {
    result = await response.json();
  } catch {
    throw new Error("Invalid server response.");
  }

  if (!response.ok || !result.success) {
    throw new Error(result.message || "Something went wrong.");
  }

  return result;
};

export const getAddressDownloadPlans = (status = "") => {
  const query = status
    ? `?status=${encodeURIComponent(status)}`
    : "";

  return apiRequest(query);
};

export const createAddressDownloadPlan = (data) =>
  apiRequest("", {
    method: "POST",
    body: JSON.stringify(data),
  });

export const updateAddressDownloadPlan = (rfId, data) =>
  apiRequest(`/${rfId}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });

export const updateAddressDownloadPlanStatus = (rfId, status) =>
  apiRequest(`/${rfId}/status`, {
    method: "PATCH",
    body: JSON.stringify({ status }),
  });

export const deleteAddressDownloadPlan = (rfId) =>
  apiRequest(`/${rfId}`, {
    method: "DELETE",
  });
